import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Theme } from '@shure/shared/models';

@Injectable({ providedIn: 'root' })
export class ThemeService {
	private readonly localStorageKey = 'theme';
	private readonly _theme$ = new BehaviorSubject<Theme>(this.getTheme());

	public readonly currentTheme$ = this._theme$.asObservable();

	constructor(@Inject(DOCUMENT) private readonly document: Document) {}

	/**
	 * Set active theme for app.
	 */
	public setTheme(theme: Theme): void {
		localStorage.setItem(this.localStorageKey, theme);
		this.document.documentElement.setAttribute('theme', theme);
		this._theme$.next(theme);
	}

	/**
	 * Get currently active theme.
	 *
	 * **Defaults to light**
	 */
	public getTheme(): Theme {
		return <Theme>localStorage.getItem(this.localStorageKey) || Theme.Light;
	}
}
